import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index/Index.vue'
import XianYu from '@/views/index/Xianyu.vue'
import Morepage from '@/views/index/detail/Morepage.vue'
import XianyuDyn from '@/views/index/XianyuDyn.vue'
import { title } from 'echarts/lib/theme/dark'

Vue.use(VueRouter)
export const routerMode = 'hash'
const routes = [
  {
    path: '/',
    redirect: to => {
      return '/index'
    }
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
    meta: {
      title: "乡村振兴大数据服务平台"
    }
  },
  {
    path: '/xianyudyn',
    name: 'XianyuDyn',
    component: XianyuDyn,
    meta: {
      title: "农业科技网络书屋"
    }
  },
  // {
  //   path: '/XianYu',
  //   name: 'XianYu',
  //   component: XianYu
  // },
  // {
  //   path: '/',
  //   name: 'index',
  //   component: XianYu
  // },
  // {
  //   path: '/Morepage',
  //   name: 'Morepage',
  //   component: Morepage
  // }
]

const router = new VueRouter({
  mode: routerMode,
  routes
})

router.beforeEach((to, from, next) => {
  // to and from are both route objects. must call `next`.
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = "乡村振兴大数据服务平台"
  }
  next()
})

export default router
